// extracted by mini-css-extract-plugin
export default {"wrapper":"_311b15c6","container":"_18311792","exclamation":"_2ca49a36","link":"_20643ef5","messageHeader":"_d21364e1"};